export default "/images/fb338142fb7715716562b3cd23cc0b88.avif";